import { TailSpin } from "react-loader-spinner";

const LoadingIcon = () => {
  return <TailSpin height={40} color={'gray'} />;
};

export default LoadingIcon;
